import type {
  CreateUserRequest,
  UpdateUserRequest,
  UserAdminView,
} from '../../services/users/users.service';
import type { EditingBaseline, UserFormState } from './users-page.types';

export const toggleTenantSelection = (tenantIds: string[], tenantId: string): string[] =>
  tenantIds.includes(tenantId)
    ? tenantIds.filter((current) => current !== tenantId)
    : [...tenantIds, tenantId];

export const buildEditDraftFromUser = (user: UserAdminView): UserFormState => ({
  displayName: user.displayName,
  username: user.username,
  email: user.email,
  password: '',
  role: user.role,
});

export const buildBaselineFromUser = (user: UserAdminView): EditingBaseline => {
  const tenantIds = user.tenantIds?.length ? user.tenantIds : [user.tenantId];
  return {
    displayName: user.displayName,
    role: user.role,
    tenantIds,
  };
};

export const buildCreatePayload = (
  form: UserFormState,
  tenantIds: string[],
): CreateUserRequest => ({
  displayName: form.displayName.trim(),
  username: form.username.trim(),
  email: form.email.trim(),
  password: form.password,
  role: form.role,
  tenantIds,
});

export const buildUpdatePayload = (
  form: UserFormState,
  tenantIds: string[],
  baseline: EditingBaseline | null,
): UpdateUserRequest => {
  const payload: UpdateUserRequest = {};
  const trimmedDisplayName = form.displayName.trim();

  if (baseline === null || trimmedDisplayName !== baseline.displayName) {
    payload.displayName = trimmedDisplayName;
  }

  if (baseline === null || form.role !== baseline.role) {
    payload.role = form.role;
  }

  const baselineTenantIdsKey = baseline ? [...baseline.tenantIds].sort().join('|') : '';
  const selectedTenantIdsKey = [...tenantIds].sort().join('|');
  if (baseline === null || selectedTenantIdsKey !== baselineTenantIdsKey) {
    payload.tenantIds = tenantIds;
  }

  if (form.password) {
    payload.password = form.password;
  }

  return payload;
};
